import React from "react";
import "../SignOutDialog/SignOutDialog.scss";
import UserImg from "../../../assets/images/vactor/placeholder-avatar.svg";
import CameraImgIcon from "../../../assets/images/vactor/white-camera.svg";
import EditTextIcon from "../../../assets/images/vactor/edit-text-field.svg";
import SignOutIcon from "../../../assets/images/vactor/signout-popup-con.svg";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { LightButton, PrimaryButton } from "../../AllButtons/AllButtons";

interface SignOutDialogProps{
  open:boolean;
  onClose: () => void;
}

function SignOutDialog({open, onClose}:SignOutDialogProps) {
  return (
    <>
      <Dialog
        className="sign-out-dialog"
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          className="sign-out-dialog-title"
          id="alert-dialog-title"
        >
         Sign Out
        </DialogTitle>
        <DialogContent className="sign-out-dialog-body">
          <div className="sign-out-block">
            <div className="sign-out-img">
              <img src={SignOutIcon} alt="" />
            </div>
            <div className="sign-out-label-title">
            Are you sure?
            </div>
            <div className="sign-out-dsc">You will be sign out from this session sign-in back to continue.</div>
          </div>
        
        </DialogContent>
        <DialogActions className="sign-out-dialog-footer">
            <PrimaryButton> Sign Out </PrimaryButton>
            <LightButton onClick={onClose}> Cancel </LightButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default SignOutDialog;
